<template>
  <pt-batch-operation class="pt-batch-operation__page"></pt-batch-operation>
</template>

<script>
import PtBatchOperation from 'cps/adult-sell-order/pt-batch-operation/withData'
export default {
  name: 'pt-batch-operation__view',
  components: {
    'pt-batch-operation': PtBatchOperation
  }
}
</script>
